import React, { useEffect } from "react";
import { ModalProps } from "../../interfaces/modal";
import { Input } from "../ui/inputs/Input";
import { usePaymentStore } from "../../stores/payment";
import { getRefund, updateRefund } from "../../api/reimboursement";
import { showToastError, showToastSuccess } from "../../services/toast";
import { createRefund } from "../../api/payments";
import { ModalButton, ModalShell } from "../ui/modals/ModalShell";

const Refund: React.FC<ModalProps> = ({
  closeModal,
  id,
  reimboursementId,
  amountTTC,
  createOrEdit,
}) => {
  const { formData, setFormData, updatePaymentBool, setUpdatePaymentBool } =
    usePaymentStore();

  useEffect(() => {
    if (createOrEdit === "edit" && reimboursementId) {
      getRefund(reimboursementId)
        .then((response) => {
          // Convert the date format from DD/MM/YYYY to YYYY-MM-DD
          const data = response.data;
          if (data.date) {
            const [day, month, year] = data.date.split("/");
            data.date = `${year}-${month}-${day}`;
          }
          setFormData(data);
        })
        .catch((err) => {
          showToastError(err.response.data.message)        
        });
    }
  }, [createOrEdit, id]);

  useEffect(() => {
    if (amountTTC && formData.amount) {
      
      if (!isNaN(Number(formData.amount)) && Number(formData.amount) > amountTTC) {
        showToastError(
          "Le montant du remboursement ne peut pas être supérieur au montant de l'encaissement"
        );
        return;
      }
    }
  }, [formData.amount, amountTTC]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (id === undefined) return;

    if (createOrEdit === "create") {
      // On envoie le montant converti
      createRefund(id, { ...formData, amount: Number(formData.amount)})
        .then(() => {
          closeModal();
          setFormData({});
          setUpdatePaymentBool(!updatePaymentBool);
          showToastSuccess("Remboursement créé avec succès");
        })
        .catch((err) => {
          showToastError(err.response.data.message)        
        });
    } else {
      if (reimboursementId) {
        updateRefund(reimboursementId, { ...formData, amount: Number(formData.amount) })
          .then(() => {
            closeModal();
            setFormData({});
            setUpdatePaymentBool(!updatePaymentBool);
            showToastSuccess("Remboursement modifié avec succès");
          })
          .catch((err) => {
            showToastError(err.response.data.message)
          });
      }
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <ModalShell
      title="Remboursement"
      subtitle={`Souhaitez vous ${
        createOrEdit === "create" ? "créer" : "modifier"
      } un remboursement ?`}
      size="sm"
      onClose={() => {
        setFormData({});
        closeModal();
      }}
      footer={
        <>
          <ModalButton
            variant="secondary"
            onClick={() => {
              setFormData({});
              closeModal();
            }}
          >
            Annuler
          </ModalButton>
          <ModalButton variant="primary" type="submit" onClick={handleSubmit}>
            {createOrEdit === "create" ? "Créer" : "Modifier"}
          </ModalButton>
        </>
      }
    >
      <div className="grid grid-cols-1 gap-3 font-Nunito sm:grid-cols-2">
        <Input
          label="Date du remboursement"
          name="date"
          value={formData.date || ""}
          onChange={handleChange}
          type="date"
          required
          clasName="w-full"
        />
        <Input
          label="Montant TTC"
          name="amount"
          value={formData.amount ?? ""}
          onChange={handleChange}
          type="number"
          required
          clasName="w-full"
        />
      </div>
    </ModalShell>
  );
};

export default Refund;
